export default function Footer() {
  const navLinks = [
    { label: "Главная", href: "#home" },
    { label: "О нас", href: "#about" },
    { label: "Условия", href: "#features" },
    { label: "Операторы", href: "#portfolio" },
    { label: "Блог", href: "#blog" },
    { label: "Контакты", href: "#contact" },
  ];

  return (
    <footer className="relative py-12 bg-background-100 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          <a href="#home" className="cursor-pointer font-bold text-xl text-foreground-950 flex items-center gap-2">
            <i className="ri-briefcase-fill text-primary-500 text-2xl w-8 h-8 flex items-center justify-center" />
            WorkTerra
          </a>
          <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-foreground-600 hover:text-primary-500 text-sm transition-colors cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
            <button className="text-foreground-600 hover:text-primary-500 text-sm transition-colors cursor-pointer whitespace-nowrap">
              Вакансии
            </button>
          </nav>
          <p className="text-foreground-500 text-xs whitespace-nowrap">
            &copy; 2026 WorkTerra
          </p>
        </div>
      </div>
    </footer>
  );
}